import AcceptInviteLegacy from '../../../banking/components/joint-account-holder/AcceptInviteLegacy';

const AcceptInviteLegacyScreen = () => {
    return <AcceptInviteLegacy />;
};

export default AcceptInviteLegacyScreen;
